import { SagaIterator } from 'redux-saga';
import { Project } from 'src/modules/common/types/Project';
import { PROJECT_EVENT_SEND } from 'src/modules/project-event/actions/ProjectEventActions';
import { ProjectEventDescriptor } from 'src/modules/project-event/types/ProjectEventDescriptor';
import { put } from 'typed-redux-saga';

export function* scheduleProjectEvent(
  project: Project,
  event: ProjectEventDescriptor,
): SagaIterator<void> {
  yield* put(PROJECT_EVENT_SEND.trigger(event, project));
}
